module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.655727f4.png";